import React from "react";
import Layout from "../Layout/Layout";
// import PageTop from "../Layout/PageTop";
import Contactcard from "../Layout/Contactcard";

const Contact = () => {
  return (
    <Layout>
      <Contactcard />
    </Layout>
  );
};

export default Contact;
